import type { CrudConfig } from '@/components/GenericCrudPage';

export const faqConfig: CrudConfig = {
  resource: 'faq',
  title: 'FAQ 管理',
  rowKey: 'id',
  searchFields: ['category', 'is_active'],
  fields: [
    { name: 'id', label: 'ID', type: 'readonly', width: 80, hideInForm: true, readonly: true },
    {
      name: 'category',
      label: '分类',
      type: 'select',
      required: true,
      width: 140,
      options: [
        { label: '账号相关', value: 'ACCOUNT', color: 'blue' },
        { label: '订单支付', value: 'PAYMENT', color: 'green' },
        { label: '考试相关', value: 'EXAM', color: 'purple' },
        { label: '学习相关', value: 'STUDY', color: 'cyan' },
        { label: '其他', value: 'OTHER' },
      ],
    },
    { name: 'question', label: '问题', type: 'text', required: true, ellipsis: true },
    { name: 'answer', label: '回答', type: 'textarea', required: true, hideInTable: true },
    { name: 'sort', label: '排序', type: 'number', width: 80, hideInSearch: true },
    { name: 'is_active', label: '启用', type: 'boolean', width: 100 },
    { name: 'created_at', label: '创建时间', type: 'datetime', width: 180, hideInForm: true, readonly: true },
  ],
};
